import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux'

import { setActiveView } from '../redux/viewSlice';

import './ViewCard.scss';

function ViewCard({ item, isPhone }) {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setActiveView(item));
    };

    return (
        <button
            className={clsx("btn view-card d-flex flex-column justify-content-start align-items-center",
                !isPhone && "mt-4 pt-3 ml-4",
                isPhone && "mt-3 pt-3")}
            onClick={handleClick}>
            <span className="card-title text-center">
                <p>{item.displayName}</p>
            </span>
            <span>
                <img src={item.thumbnailSource} alt={item.displayName} />
            </span>
        </button>
    );
}

export default ViewCard;